import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    formContainer: 'my-10 flex flex-col gap-12',
    formTitle: 'heading-xl mb-5'
  }
});
